import { create } from 'zustand';
import type { Workflow, WorkflowRun } from './workflow-types';

interface WorkflowState {
  workflows: Workflow[];
  runs: WorkflowRun[];
  selectedWorkflow: Workflow | null;
  loading: boolean;
  error: string | null;
  setWorkflows: (workflows: Workflow[]) => void;
  setRuns: (runs: WorkflowRun[]) => void;
  addWorkflow: (workflow: Workflow) => void;
  updateWorkflow: (id: string, data: Partial<Workflow>) => void;
  removeWorkflow: (id: string) => void;
  setSelectedWorkflow: (workflow: Workflow | null) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
}

export const useWorkflowStore = create<WorkflowState>((set) => ({
  workflows: [],
  runs: [],
  selectedWorkflow: null,
  loading: false,
  error: null,
  setWorkflows: (workflows) => set({ workflows }),
  setRuns: (runs) => set({ runs }),
  addWorkflow: (workflow) => set((state) => ({ workflows: [...state.workflows, workflow] })),
  updateWorkflow: (id, data) =>
    set((state) => ({
      workflows: state.workflows.map((w) => (w.id === id ? { ...w, ...data } : w)),
      selectedWorkflow: state.selectedWorkflow?.id === id ? { ...state.selectedWorkflow, ...data } : state.selectedWorkflow,
    })),
  removeWorkflow: (id) =>
    set((state) => ({
      workflows: state.workflows.filter((w) => w.id !== id),
      selectedWorkflow: state.selectedWorkflow?.id === id ? null : state.selectedWorkflow,
    })),
  setSelectedWorkflow: (workflow) => set({ selectedWorkflow: workflow }),
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
}));
